import React from 'react';
import { useLocation } from 'react-router-dom';
import { FiAlertTriangle } from 'react-icons/fi';
import { useSystemSettings } from '../contexts/SystemSettingsContext';

function MaintenanceBanner() {
  const { settings, loading } = useSystemSettings();
  const location = useLocation();

  const userRole =
    typeof window !== 'undefined'
      ? localStorage.getItem('userType') || localStorage.getItem('userRole')
      : null;
  const isAdmin = userRole === 'admin';
  const isAdminPath = location.pathname.startsWith('/admin');

  if (loading || !settings?.maintenance || isAdmin || isAdminPath) {
    return null;
  }

  const Wrapper = 'div';

  return (
    <Wrapper
      role="alert"
      className="fixed top-0 left-0 right-0 z-[9999] bg-amber-600 text-gray-900 px-4 py-3 shadow-lg border-b border-amber-700"
    >
      <Wrapper className="max-w-5xl mx-auto flex items-start gap-3 text-sm sm:text-base">
        <FiAlertTriangle className="w-5 h-5 shrink-0 mt-0.5" aria-hidden />
        <p className="text-left font-medium leading-snug">
          La plateforme Liberty est en maintenance. Certaines fonctionnalités sont
          temporairement indisponibles. Merci de réessayer plus tard.
        </p>
      </Wrapper>
    </Wrapper>
  );
}

export default MaintenanceBanner;
